export default "__VITE_ASSET__8FvOGQNq__"